import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core"
import { AddAPhoto, Collections } from "@material-ui/icons"

/**
 * Pergunta de onde inserir a foto: do dispositivo (câmera/arquivos) ou da galeria
 * (fotos já cadastradas da operação). Reutilizável nas telas de edição de produto.
 */
export default function DialogEscolherOrigemFoto({ open, onClose, onDispositivo, onGaleria }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Inserir foto</DialogTitle>
            <DialogContent>
                <p style={{ marginTop: 0, color: "#555" }}>De onde você quer inserir a foto?</p>
                <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <Button
                        variant="contained"
                        startIcon={<AddAPhoto />}
                        onClick={onDispositivo}
                        style={{
                            flex: 1,
                            minWidth: 140,
                            backgroundColor: "#4e73df",
                            color: "#fff",
                            textTransform: "none",
                        }}
                    >
                        Do dispositivo
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<Collections />}
                        onClick={onGaleria}
                        style={{
                            flex: 1,
                            minWidth: 140,
                            backgroundColor: "#14A44D",
                            color: "#fff",
                            textTransform: "none",
                        }}
                    >
                        Da galeria
                    </Button>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}
